import { Map } from 'immutable';

import { FIND, OPERATIONS, REPLACE } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { VALUE } from '../../../../constants/product';
import { EBAY } from '../../../../constants/channels';

export function condition({ preview }) {
  const payload = [];

  if (preview.getIn([ATTRIBUTE.CONDITION, VALUE])) {
    payload.push(Map({ type: OPERATIONS[EBAY].CONDITION_ID, value: preview.getIn([ATTRIBUTE.CONDITION, VALUE]) }));
  }

  if (preview.getIn([ATTRIBUTE.CONDITION, 'operation'])) {
    switch (preview.getIn([ATTRIBUTE.CONDITION, 'operation'])) {
      case OPERATIONS[EBAY].CONDITION_DESCRIPTION.FIND_AND_REPLACE: {
        payload.push(
          Map({
            type: preview.getIn([ATTRIBUTE.CONDITION, 'operation']),
            value: Map({
              find: preview.getIn([ATTRIBUTE.CONDITION, ATTRIBUTE.DESCRIPTION, FIND], ''),
              replace: preview.getIn([ATTRIBUTE.CONDITION, ATTRIBUTE.DESCRIPTION, REPLACE], ''),
            }),
          })
        );
        break;
      }

      default: {
        payload.push(
          Map({
            type: preview.getIn([ATTRIBUTE.CONDITION, 'operation']),
            value: preview.getIn([ATTRIBUTE.CONDITION, ATTRIBUTE.DESCRIPTION, VALUE], ''),
          })
        );

        break;
      }
    }
  }

  return { payload };
}
